import styled from 'styled-components'
import breakpoints from '../../../config/settings/breakpoints'
import { variantStyles } from '../../../components/Basics/Typography.styles'

export const Container = styled.section`
  grid-area: skills;
  margin-inline-end: 1rem;
  margin-inline-start: 1rem;
  margin-top: 2rem;
`

export const Grid = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing.xl};
  margin-top: ${({ theme }) => theme.spacing.lg};

  @media ${breakpoints.device.sm} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${breakpoints.device.lg} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`

export const Category = styled.div`
  min-width: 0;
`

export const CategoryTitle = styled.p`
  letter-spacing: 0.08em;
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  text-transform: uppercase;
  ${({ theme }) => variantStyles({ variant: 'caption', theme })}
`

export const ItemList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const Item = styled.li`
  margin: 0 0 ${({ theme }) => theme.spacing.xs};
  ${({ theme }) => variantStyles({ variant: 'body2', theme })}

  &:last-child {
    margin-bottom: 0;
  }
`
